import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";
import Restful from "lib/restful";
import GaHelper from "lib/gaHelper";
import config from "lib/fr-config";

const UNIT_LENGTH = config.outfitList.LENGTH;
const EXP_MINUTE = 30;

/**
 * SCROLL_END_OUTFIT_COUNT:
 * 이 숫자이상의 아웃핏을 받으면 자동으로 스크롤이 종료된다.
 * (= isEnd 변수가 true로 켜진다.)
 */
const SCROLL_END_OUTFIT_COUNT = 60;

const SET_OUTFIT_LIST = "gallery/SET_OUTFIT_LIST";
const SET_EXPIRATION_DATE = "gallery/SET_EXPIRATION_DATE";
const SET_IS_END = "gallery/SET_IS_END";
const SET_IS_LOADING = "gallery/SET_IS_LOADING";
const INIT_MUTABLE_DATA = "gallery/INIT_MUTABLE_DATA";
const INIT_ALL_DATA = "gallery/INIT_ALL_DATA";

const setOutfitList = createAction(SET_OUTFIT_LIST);
const setExpirationDate = createAction(SET_EXPIRATION_DATE);
const setIsEnd = createAction(SET_IS_END);
const setIsLoading = createAction(SET_IS_LOADING);
const initMutableData = createAction(INIT_MUTABLE_DATA);
const initAllData = createAction(INIT_ALL_DATA);

const getGalleryState = ({ getState }) => {
  const galleryState = getState().gallery.toJS();
  return galleryState;
};

const getIsLoading = ({ getState }) => {
  const galleryState = getGalleryState({ getState });
  const { isLoading } = galleryState;
  return isLoading;
};

const getLastHash = list => {
  if (list.length === 0) return undefined;
  const length = list.length;
  return list[length - 1]["outfitHash"];
};

const requestGalleryList = async ({ outfitList, idToken }) => {
  const length = UNIT_LENGTH;
  const lastHash = getLastHash(outfitList);
  const { code, res, errInfo } = await Restful.getGalleryListAPI({
    idToken,
    lastHash,
    length
  });
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  } else if (code === "UnauthorizedUser") {
    throw Error("Unauthorized Person Request Gallery");
  } else {
    return { list: res.list };
  }
};

const checkExpDate = ({ getState }) => {
  const galleryState = getGalleryState({ getState });
  const { expirationDate } = galleryState;
  if (!expirationDate) return { needUpdate: true };
  const nowDate = new Date();
  return { needUpdate: nowDate > expirationDate ? true : false };
};

const setExpDate = ({ dispatch }) => {
  const expirationDate = new Date();
  expirationDate.setMinutes(expirationDate.getMinutes() + EXP_MINUTE);
  dispatch(setExpirationDate(expirationDate));
};

const concatGalleryList = async ({ getState, dispatch, idToken }) => {
  const galleryState = getGalleryState({ getState });
  const { outfitList } = galleryState;
  const { list } = await requestGalleryList({ outfitList, idToken });
  const newList = outfitList.concat(list);
  dispatch(setOutfitList(newList));
  dispatch(setIsEnd(list.length < UNIT_LENGTH));
  if (newList.length >= SCROLL_END_OUTFIT_COUNT) {
    dispatch(setIsEnd(true));
  }
  GaHelper.setGARequestOutfitListEvent({
    type: "galleryOutfitList",
    pageNum: outfitList.length / UNIT_LENGTH + 1
  });
};

export const initList = idToken => async (dispatch, getState) => {
  const isLoading = getIsLoading({ getState });
  if (isLoading) return null;

  dispatch(setIsLoading(true));

  const { needUpdate } = checkExpDate({ getState });

  if (needUpdate) {
    dispatch(initMutableData());
    await concatGalleryList({ getState, dispatch, idToken });
    setExpDate({ dispatch });
  }
  dispatch(setIsLoading(false));
};

export const requestNextList = idToken => async (dispatch, getState) => {
  const galleryState = getGalleryState({ getState });
  const { isEnd } = galleryState;
  const isLoading = getIsLoading({ getState });

  if (isLoading || isEnd) return null;

  dispatch(setIsLoading(true));
  await concatGalleryList({ getState, dispatch, idToken });
  dispatch(setIsLoading(false));
};

export const deleteAllData = () => (dispatch, getState) => {
  dispatch(initAllData());
};

const initialState = fromJS({
  outfitList: [],
  expirationDate: null,
  isEnd: false,
  isLoading: false
});

export default handleActions(
  {
    [SET_OUTFIT_LIST]: (state, action) => {
      const outfitList = action.payload;
      return state.set("outfitList", fromJS(outfitList));
    },
    [SET_EXPIRATION_DATE]: (state, action) => {
      const expirationDate = action.payload;
      return state.set("expirationDate", fromJS(expirationDate));
    },
    [SET_IS_END]: (state, action) => {
      const isEnd = action.payload;
      return state.set("isEnd", fromJS(isEnd));
    },
    [SET_IS_LOADING]: (state, action) => {
      const isLoading = action.payload;
      return state.set("isLoading", fromJS(isLoading));
    },
    [INIT_MUTABLE_DATA]: (state, action) => {
      const { outfitList, expirationDate, isEnd } = initialState.toJS();
      return state
        .set("outfitList", fromJS(outfitList))
        .set("expirationDate", fromJS(expirationDate))
        .set("isEnd", fromJS(isEnd));
    },
    [INIT_ALL_DATA]: (state, action) => {
      return initialState;
    }
  },
  initialState
);
